import { Theme, styled } from "@material-ui/core";
import Box from "@material-ui/core/Box";

export default styled(Box)<Theme>(({ theme }) => ({
  fontWeight: theme.typography.fontWeightBold,
  fontSize: "36px",
  lineHeight: "120%",
}));
